import { useMemo } from 'react';
import type { FundingActivityData, ZoomLevel } from '../types';
import { processChartData } from '../utils';

export const useProcessedData = (data: FundingActivityData[], zoomLevel: ZoomLevel) => {
    return useMemo(() => {
        return processChartData(data, zoomLevel);
    }, [data, zoomLevel]);
};
